// Animation items keys
export const ROUND_ICONS = 'roundIcons';
export const PORTRAIT_BACKGROUND = 'portraitBackground';
export const IMAGE = 'image';
export const CONTAINER = 'container';
export const BACKGROUND = 'background';
// Animation types
export const ANIMATE_ON_OPEN = 'animateOnOpen';
export const ANIMATE_ON_SHOW_DETAILS = 'animateOnShowDetails';
export const ANIMATE_ON_HIDE_DETAILS = 'animateOnHideDetailes';
export const ANIMATE_ON_ORIENTATION = 'animateOnOrientation';
